const styles = {
  global: {
    "*, *::before, *::after": {
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },

    ".js-focus-visible :focus:not([data-focus-visible-added])": {
      outline: "none",
      boxShadow: "none",
    },

    html: { width: "100%" },

    body: {
      overflowX: "hidden",
      overflowY: "scroll",
      fontFamily: "Inter, sans-serif",
      color: "text.300",
      bg: "base.d200",
    },

    "button, a": {
      WebkitTapHighlightColor: "transparent",
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      KhtmlUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none",
    },

    "::-webkit-scrollbar": {
      width: "5px",
    },
    "::-webkit-scrollbar-track": {
      backgroundColor: "base.d200",
    },
    "::-webkit-scrollbar-thumb": {
      backgroundColor: "primary.200",
      borderRadius: "2px",
      border: "0px solid transparent",
      backgroundClip: "content-box",
    },
  },
}

export default styles
